import { Button } from '@gearbelt/ui/components';

import CloseIcon from '@/components/icons/close';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

export function LockedFieldChangeDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col gap-2.5">
        <DialogClose className="focus:ring-default-blue data-[state=open]:bg-default-blue/10 data-[state=open]:text-default-text ml-auto size-4 cursor-pointer rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:pointer-events-none">
          <CloseIcon className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogClose>

        <DialogTitle hideCloseButton className="justify-center text-center">
          Can't change this option
        </DialogTitle>

        <DialogDescription className="text-center">
          This Schedule Check needs a reading or completion date. Changing the option would hide those fields.
        </DialogDescription>

        <div className="mt-4 flex justify-center">
          <Button type="button" variant="success" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
